import { Modal } from "@mantine/core";
import React from "react";

import ModalHeader from "components/ModalHeader";
import AddHiringDetailForm from "./addHiringForm";
// import EditDepartmentForm from "./editDepartmentForm";

type EditDepartmentProps = {
  opened: boolean;
  onClose: () => void;
};

function AddHiringModal({ opened, onClose }: EditDepartmentProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      size="lg"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Employment Details"
        onClose={onClose}
        ariaLabel="Close create Department modal"
      />
      <AddHiringDetailForm onClose={onClose} />
    </Modal>
  );
}

export default AddHiringModal;
